import { Global } from '@emotion/react';
import React from 'react';

const Fonts = (): JSX.Element => (
  <Global
    styles={`
      /* Nunito */
      // Font license available at https://hjernenhjertet-no.ramboll.com/public/fonts/OFL.txt
      @font-face {
        font-family: 'Nunito';
        src:url('/fonts/Nunito-VariableFont_wght.woff2') format('woff2'), url('/fonts/Nunito-VariableFont_wght.woff') format('woff');
        font-feature-settings: 'ss02' on;
        font-display: swap;
      }

      /* raleway */
      @font-face {
        font-family: 'Raleway-Font';
        src: url('/public/fonts/Raleway-VariableFont_wght.ttf');
        font-weight: 700;
        font-style: normal;
        font-display: swap;
      }
    `}
  />
);

export default Fonts;
